import React, { useEffect, useState } from 'react';
import { Handles, Rail, Slider, Ticks, Tracks } from 'react-compound-slider';

import { Handle, KeyboardHandle, Tick, TooltipRail, Track } from './priceRangeFilterComponents';
import Input from '../../form-elements/Input';

function PriceRangeFilter({ minPrice, maxPrice, currentMinPrice, currentMaxPrice, onFilterChanged }) {
    const [[inputMinPrice, inputMaxPrice], setInputValues] = useState(() => [currentMinPrice, currentMaxPrice]);
    const [inputSubmitCounter, setInputSubmitCounter] = useState(0);
    const [inputFocus, setInputFocus] = useState(false);

    useEffect(() => {
        setInputValues([currentMinPrice, currentMaxPrice]);
    }, [currentMinPrice, currentMaxPrice, inputSubmitCounter]);

    const onInputSubmit = () => {
        const newMinPrice = inputMinPrice === '' ? minPrice : Math.floor(inputMinPrice);
        const newMaxPrice = inputMaxPrice === '' ? maxPrice : Math.ceil(inputMaxPrice);

        setInputSubmitCounter(inputSubmitCounter + 1);
        if (newMinPrice > newMaxPrice) {
            onFilterChanged({ minPrice: newMaxPrice, maxPrice: newMinPrice });
        } else {
            onFilterChanged({ minPrice: newMinPrice, maxPrice: newMaxPrice });
        }
        setInputFocus(false);
    };

    const onSliderChange = ([minPrice, maxPrice]) => {
        onFilterChanged({ minPrice, maxPrice });
    };

    const onKeyPress = e => {
        if (e.key === 'Enter') {
            onInputSubmit();
        }
    };

    return (
        <div>
            <div className="uk-flex uk-margin">
                <Input
                    className=""
                    name="priceFrom"
                    id="priceFrom"
                    value={inputFocus? inputMinPrice : inputMinPrice?.toLocaleString('de-DE')}
                    label="von €"
                    onChange={({ value }) => setInputValues([value, inputMaxPrice])}
                    onBlur={onInputSubmit}
                    onKeyPress={onKeyPress}
                    onFocus={() => setInputFocus(true)}
                    type={inputFocus? 'number' : 'text'}
                />
                <Input
                    className=""
                    name="priceTo"
                    id="priceTo"
                    value={inputFocus? inputMaxPrice : inputMaxPrice?.toLocaleString('de-DE')}
                    label="bis €"
                    onChange={({ value }) => setInputValues([inputMinPrice, value])}
                    onBlur={onInputSubmit}
                    onKeyPress={onKeyPress}
                    onFocus={() => setInputFocus(true)}
                    type={inputFocus? 'number' : 'text'}
                />
            </div>
            <div tabIndex={-1} style={{ height: 32, width: '100%', paddingLeft: 12, paddingRight: 12 }}>
                <Slider
                    mode={3}
                    step={1}
                    domain={[minPrice, maxPrice]}
                    rootStyle={{ position: 'relative', width: '100%' }}
                    onChange={onSliderChange}
                    values={[currentMinPrice, currentMaxPrice]}
                >
                    <Rail>
                        {({ getRailProps, getEventData }) => <TooltipRail getRailProps={getRailProps} getEventData={getEventData} />}
                    </Rail>
                    <Handles>
                        {({ handles, activeHandleID, getHandleProps }) => (
                            <div className="slider-handles">
                                {handles.map(handle => (
                                    <KeyboardHandle
                                        key={handle.id}
                                        handle={handle}
                                        domain={[minPrice, maxPrice]}
                                        isActive={handle.id === activeHandleID}
                                        getHandleProps={getHandleProps}
                                        label={Math.min(...handles.map(h => h.value)) == handle.value ? `Preis von ${handle.value}` : `Preis bis ${handle.value}` }
                                    />
                                ))}
                            </div>
                        )}
                    </Handles>
                    <Tracks left={false} right={false}>
                        {({ tracks, getTrackProps }) => (
                            <div className="slider-tracks" tabIndex={0}>
                                {tracks.map(({ id, source, target }) => (
                                    <Track key={id} source={source} target={target} getTrackProps={getTrackProps} />
                                ))}
                            </div>
                        )}
                    </Tracks>
                    <Ticks count={5}>
                        {({ ticks }) => (
                            <div className="slider-ticks">
                                {ticks.map(tick => (
                                    <Tick key={tick.id} tick={tick} count={ticks.length} />
                                ))}
                            </div>
                        )}
                    </Ticks>
                </Slider>
            </div>
        </div>
    );
}

export default PriceRangeFilter;
